<template>
  <div class="billing">
    <!--- Billing plan card -->
    <billing-plan class="spacing-bottom--24 spacing-top--24"></billing-plan>
    <!--- Billing method card -->
    <billing-method class="spacing-bottom--24"></billing-method>
    <!--- Company details form -->
    <company-details class="spacing-bottom--24"></company-details>
    <!--- Billing history list -->
    <billing-history class="spacing-bottom--24"></billing-history>
  </div>
</template>

<script>
  import BillingPlan from "./BillingPlan.vue";
  import BillingMethod from "./BillingMethod.vue";
  import CompanyDetails from "./CompanyDetails.vue";
  import BillingHistory from "./BillingHistory.vue";
  import { formErrorMessage } from "@/utility/formErrorMessage";

  export default {
    name: "Billing",
    components: {
      BillingPlan,
      BillingMethod,
      CompanyDetails,
      BillingHistory,
    },
    watch: {
      // In case organization is changed in organization select, update billing data
      "$store.state.currentlyActiveOrganization.id": {
        immediate: true,
        async handler(organizationId) {
          if (!organizationId) return;

          await this.loadBillingData();
        },
      },
    },
    methods: {
      async loadBillingData() {
        try {
          this.$store.dispatch("billing/loadSubscriptionData");
          this.$store.dispatch("billing/getCompanyDetails");
          this.$store.dispatch("billing/getPaymentMethods");
          this.$store.dispatch("billing/getInvoices");
        } catch (e) {
          this.$admin.toast.error(formErrorMessage(e, this.$t("generic.error")));
        }
      },
    },
  };
</script>
